import { render } from "./SliderTypeComponent.vue?vue&type=template&id=4fc55d16&scoped=true"
import script from "./SliderTypeComponent.vue?vue&type=script&lang=js"
export * from "./SliderTypeComponent.vue?vue&type=script&lang=js"

import "./SliderTypeComponent.vue?vue&type=style&index=0&id=4fc55d16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc55d16"]])

export default __exports__